import {HttpStatus} from "../../../common/Constants";
import {mapToObjectDDL} from "../../../common/mapper";
import * as R from "ramda";
import {formGroup} from "./config";

const mapSalesProgramDates = (salesProgram) => {
    const [day, month, year] = (salesProgram?.tanggalSelesai || "")
        .split("-")
        .map(Number);
    const tanggalSelesai = new Date(year, month - 1, day);
    const gracePeriod = new Date(tanggalSelesai);

    gracePeriod.setDate(
        gracePeriod.getDate() + Number(salesProgram?.gracePeriod || 0)
    );

    return {
        tanggalSelesai,
        gracePeriod,
    };
};

const fetchDataDetail = async (tabKey, promises) => {
    let data = {};
    let error = false;
    if (tabKey === "NOS") {
        const res = await Promise.all(promises);
        let dataPembeli = {};
        let dataPemilik = {};
        let dataPhoto = {};
        let dataUnit = {};
        let dataPackage = {};
        let dataTransaction = {};
        let dataDelivery = {};
        let dataReferral = {};
        let dataNote = {};

        if (res[0].ok && res[0].data.status === HttpStatus.SUCCESS) {
            const {data} = res[0].data;
            dataPembeli = {
                ...res[0].data.data,
                isCompany: data?.perusahaan || false,
                province: {label: data?.province?.provinceName, value: data?.province?.id},
                kabkot: {label: data?.kabkot?.kabKotName, value: data?.kabkot?.kabKotId},
                kecamatan: {label: data?.kecamatan?.kecamatanName, value: data?.kecamatan?.id},
                kelurahan: {label: data?.kelurahan?.kelurahanname, value: data?.kelurahan?.id},
                zipCode: {label: data?.zipCode, value: data?.zipCode},
                gender: {label: data?.gender?.value, value: data?.gender?.key},
                job1: {label: data?.job1?.value, value: data?.job1?.key},
                job2: {label: data?.job2?.value, value: data?.job2?.key},
                religion: {label: data?.religion?.value, value: data?.religion?.key},
                interest: Array.isArray(data?.interest) && data.interest.length > 0
                    ? {
                        label: data.interest[0].value,
                        value: data.interest[0].key,
                    }
                    : data?.interest
                        ? {
                            label: data.interest.value,
                            value: data.interest.id,
                        }
                        : null,
                hobby: Array.isArray(data?.hobby) && data.hobby.length > 0
                    ? {
                        label: data.hobby[0].value,
                        value: data.hobby[0].key,
                    }
                    : data?.hobby
                        ? {
                            label: data.hobby.value,
                            value: data.hobby.id,
                        }
                        : null,
            };
        }

        if (res[1].ok && res[1].data.status === HttpStatus.SUCCESS) {
            const {data} = res[1].data;
            dataPemilik = {
                ...res[1].data.data,
                isBuyer: data?.pembeli || false,
                province: {label: data?.province?.provinceName, value: data?.province?.id},
                kabkot: {label: data?.kabkot?.kabKotName, value: data?.kabkot?.kabKotId},
                kecamatan: {label: data?.kecamatan?.kecamatanName, value: data?.kecamatan?.id},
                kelurahan: {label: data?.kelurahan?.kelurahanname, value: data?.kelurahan?.id},
                zipCode: {label: data?.zipCode, value: data?.zipCode},
                gender: {label: data?.gender?.value, value: data?.gender?.key},
                job1: {label: data?.job1?.value, value: data?.job1?.key},
                job2: {label: data?.job2?.value, value: data?.job2?.key},
                religion: {label: data?.religion?.value, value: data?.religion?.key},
                interest: Array.isArray(data?.interest) && data.interest.length > 0
                    ? {
                        label: data.interest[0].value,
                        value: data.interest[0].key,
                    }
                    : data?.interest
                        ? {
                            label: data.interest.value,
                            value: data.interest.key,
                        }
                        : null,
                hobby: Array.isArray(data?.hobby) && data.hobby.length > 0
                    ? {
                        label: data.hobby[0].value,
                        value: data.hobby[0].key,
                    }
                    : data?.hobby
                        ? {
                            label: data.hobby.value,
                            value: data.hobby.key,
                        }
                        : null,
            };
        }

        if (res[2].ok && res[2].data.status === HttpStatus.SUCCESS) {
            dataPhoto = {
                ktpBase64: res[2].data.data.ktpBase64,
                kartuKeluargaBase64: res[2].data.data.kartuKeluargaBase64
            };
        }

        if (res[3].ok && res[3].data.status === HttpStatus.SUCCESS) {
            const {data} = res[3].data;
            dataUnit = {
                kodeVariant: {label: data?.dataVariant?.kodeVariant, value: data?.dataVariant?.kodeVariant},
                namaVariant: data?.dataVariant?.namaVariant,
                idWarna: {label: data?.dataWarna?.kodeWarna, value: data?.dataWarna?.id},
                namaWarnaKomersil: data?.dataWarna?.namaWarnaKomersil,
                tipe: data?.dataTypeAndSeriesDTO?.typeName,
                series: data?.dataTypeAndSeriesDTO?.seriesDTO?.seriesName,
                nomorMesin: data?.noSin,
                nomorRangka: data?.noKa,
            };
        }

        if (res[4].ok && res[4].data.status === HttpStatus.SUCCESS) {
            const {dataKsu, dataHadiah, dataBarangLain, dataPart} = res[4].data.data?.detailPaket;
            dataPackage = {
                selectedPackage: mapToObjectDDL(res[4].data.data?.paket?.packageName, res[4].data.data?.paket?.packageId),
                dataTable: {
                    ksu: R.isEmpty(dataKsu) ? [] : dataKsu.map(item => {
                        return {
                            id: Math.random(),
                            category: {label: item?.category?.value, value: item?.category?.key},
                            kode: item?.kodeKSU,
                            name: {label: item?.name, value: item?.name},
                            satuan: item?.satuan?.value,
                            jumlah: item?.qty || 0,
                            action: {
                                readOnly: true,
                                saved: true,
                            }
                        }
                    }),
                    hadiah: R.isEmpty(dataHadiah) ? [] : dataHadiah.map(item => {
                        return {
                            id: Math.random(),
                            category: {label: item?.categoryDTO?.value, value: item?.categoryDTO?.key},
                            kode: item?.kodeHadiah,
                            name: {label: item?.nameHadiah, value: item?.nameHadiah},
                            satuan: item?.satuanDTO?.value,
                            jumlah: item?.qty || 0,
                            action: {
                                readOnly: true,
                                saved: true,
                            }
                        }
                    }),
                    barangLain: R.isEmpty(dataBarangLain) ? [] : dataBarangLain.map(item => {
                        return {
                            id: Math.random(),
                            category: {label: item?.categoryDTO?.value, value: item?.categoryDTO?.key},
                            kode: item?.kodeotheritem,
                            name: {label: item?.nameotheritem, value: item?.nameotheritem},
                            satuan: item?.satuanDTO?.value,
                            jumlah: item?.qty || 0,
                            action: {
                                readOnly: true,
                                saved: true,
                            }
                        }
                    }),
                    part: R.isEmpty(dataPart) ? [] : dataPart.map(item => {
                        return {
                            id: Math.random(),
                            category: {label: item?.partCategory?.value, value: item?.partCategory?.key},
                            kode: item?.kodePart,
                            name: {label: item?.partName, value: item?.partName},
                            satuan: item?.satuan?.value,
                            jumlah: item?.qty || 0,
                            action: {
                                readOnly: true,
                                saved: true,
                            }
                        }
                    }),
                }
            }
        }

        if (res[5].ok && res[5].data.status === HttpStatus.SUCCESS) {
            const salesProgram =
                res[5].data.data.detailTransaction?.pembayaranUnit?.salesProgram;
            const salesProgramDates = mapSalesProgramDates(salesProgram);
            const headerTransaction = {
                ...res[5].data.data.headerTransaction,
                salesPersonId: {
                    label: res[5].data.data.headerTransaction?.salesPersonId?.name,
                    value: res[5].data.data.headerTransaction?.salesPersonId?.employeeId,
                    marketingLevel: res[5].data.data.headerTransaction?.salesPersonId?.marketingLevel,
                    salesType: res[5].data.data.headerTransaction?.salesPersonId?.salesType?.key || null,
                },
                levelMarketing: res[5].data.data.headerTransaction?.salesPersonId?.marketingLevel
            };
            const dataBank = res[5].data.data.detailTransaction?.pembayaranKonsumen?.bank;
            const detailTransaction = {
                ...res[5].data.data.detailTransaction,
                pembayaranUnit: {
                    ...res[5].data.data.detailTransaction?.pembayaranUnit,
                    salesProgramId: {
                        label: salesProgram?.namaPromo,
                        value: salesProgram?.promoId,
                        id: salesProgram?.id,
                        ...salesProgramDates,
                    },
                    tipePayment: {
                        label: res[5].data.data.detailTransaction?.pembayaranUnit?.tipePayment,
                        value: res[5].data.data.detailTransaction?.pembayaranUnit?.tipePayment
                    },
                    leasing: {
                        label: res[5].data.data.detailTransaction?.pembayaranUnit?.leasing?.leasingName,
                        value: res[5].data.data.detailTransaction?.pembayaranUnit?.leasing?.leasingId
                    }
                },
                dataTransaksiTambahan: {
                    ...res[5].data.data.detailTransaction?.dataTransaksiTambahan,
                    ppn: mapToObjectDDL(
                        res[5].data.data.detailTransaction?.dataTransaksiTambahan?.ppn?.value,
                        res[5].data.data.detailTransaction?.dataTransaksiTambahan?.ppn?.key
                    )
                },
                pembayaranKonsumen: {
                    ...res[5].data.data.detailTransaction?.pembayaranKonsumen,
                    bank: mapToObjectDDL( `${dataBank?.bankName} - ${dataBank?.accountNumber}`, dataBank?.bankCode)
                }
            };
            dataTransaction = {
                headerTransaction,
                detailTransaction
            }
        }

        if (res[6]?.ok && res[6]?.data?.status === HttpStatus.SUCCESS) {
            const data = res[6].data.data;

            dataDelivery = {
                ...data,
                alamatType: data?.tipeAlamatPengiriman,
                province: {
                    label: data?.province?.provinceName,
                    value: data?.province?.id,
                },
                kabKot: {
                    label: data?.kabKot?.kabKotName,
                    value: data?.kabKot?.kabKotId,
                },
                kecamatan: {
                    label: data?.kecamatan?.kecamatanName,
                    value: data?.kecamatan?.id,
                },
                kelurahan: {
                    label: data?.kelurahan?.kelurahanname,
                    value: data?.kelurahan?.id,
                },
                kodePos: {
                    label: data?.kodePos,
                    value: data?.kodePos,
                },
            };
        }

        if (res[7].ok && res[7].data.status === HttpStatus.SUCCESS) {
            const {data} = res[7].data;
            dataReferral = {
                ...res[7].data.data,
                isMakelarProfessional: data?.makelarProfessional || false,
                province: {label: data?.province?.provinceName, value: data?.province?.id},
                kabkot: {label: data?.kabkot?.kabKotName, value: data?.kabkot?.kabKotId},
                kecamatan: {label: data?.kecamatan?.kecamatanName, value: data?.kecamatan?.id},
                kelurahan: {label: data?.kelurahan?.kelurahanname, value: data?.kelurahan?.id},
                zipCode: {label: data?.zipCode, value: data?.zipCode},
                gender: {label: data?.gender?.value, value: data?.gender?.key},
                job1: {label: data?.job1?.value, value: data?.job1?.key},
                job2: {label: data?.job2?.value, value: data?.job2?.key},
                religion: {label: data?.religion?.value, value: data?.religion?.key},
                interest: Array.isArray(data?.interest) && data.interest.length > 0
                    ? {
                        label: data.interest[0].value,
                        value: data.interest[0].key,
                    }
                    : data?.interest
                        ? {
                            label: data.interest.value,
                            value: data.interest.id,
                        }
                        : null,
                hobby: Array.isArray(data?.hobby) && data.hobby.length > 0
                    ? {
                        label: data.hobby[0].value,
                        value: data.hobby[0].key,
                    }
                    : data?.hobby
                        ? {
                            label: data.hobby.value,
                            value: data.hobby.id,
                        }
                        : null,
            };
        }

        if (res[8].ok && res[8].data.status === HttpStatus.SUCCESS) {
            const {data} = res[8].data;
            dataNote = {
                note: data?.note
            }
        }

        error = [res[0], res[1], res[2], res[3], res[4], res[5], res[6], res[7]]
            .some(r => r.ok && r.data.status === HttpStatus.FAILED);

        data = {
            dataPembeli,
            dataPemilik,
            dataPhoto,
            dataUnit,
            dataPackage,
            dataTransaction,
            dataDelivery,
            dataReferral,
            dataNote,
        }
    }

    if (tabKey === "DGI") {
        const res = await Promise.all(promises);
        let dataPembeli = {};
        let dataPemilik = {};
        let dataUnit = {};

        if (res[0].ok && res[0].data.status === HttpStatus.SUCCESS) {
            const data = res[0].data.data?.buyerDataDGIDTO;
            dataPembeli = {
                ...data,
                isCompany: data?.perusahaan || false,
                memberId: data?.customerId,
                province: {label: data?.province?.provinceName, value: data?.province?.id},
                kabkot: {label: data?.kabkot?.kabKotName, value: data?.kabkot?.kabKotId},
                kecamatan: {label: data?.kecamatan?.kecamatanName, value: data?.kecamatan?.id},
                kelurahan: {label: data?.kelurahan?.kelurahanname, value: data?.kelurahan?.id},
                zipCode: {label: data?.zipCode, value: data?.zipCode},
                gender: {label: data?.gender?.value, value: data?.gender?.key},
                job1: {label: data?.job1?.value, value: data?.job1?.key},
                job2: {label: data?.job2?.value, value: data?.job2?.key},
                religion: {label: data?.religion?.value, value: data?.religion?.key},
                interest: Array.isArray(data?.interest) && data.interest.length > 0
                    ? {
                        label: data.interest[0].value,
                        value: data.interest[0].key,
                    }
                    : data?.interest
                        ? {
                            label: data.interest.value,
                            value: data.interest.id,
                        }
                        : null,
                hobby: Array.isArray(data?.hobby) && data.hobby.length > 0
                    ? {
                        label: data.hobby[0].value,
                        value: data.hobby[0].key,
                    }
                    : data?.hobby
                        ? {
                            label: data.hobby.value,
                            value: data.hobby.id,
                        }
                        : null,
            };
        }

        if (res[1].ok && res[1].data.status === HttpStatus.SUCCESS) {
            const data = res[1].data.data.buyerDataDGIDTO;
            const resDataPembeli = res[0].data.data?.buyerDataDGIDTO;
            const pembeliIsPemilik = data?.nik === resDataPembeli?.nik || false;
            dataPemilik = pembeliIsPemilik ? {
                ...dataPembeli,
                isBuyer: pembeliIsPemilik
            } : {
                ...data,
                isBuyer: pembeliIsPemilik,
                memberId: data?.customerId,
                province: {label: data?.province?.provinceName, value: data?.province?.id},
                kabkot: {label: data?.kabkot?.kabKotName, value: data?.kabkot?.kabKotId},
                kecamatan: {label: data?.kecamatan?.kecamatanName, value: data?.kecamatan?.id},
                kelurahan: {label: data?.kelurahan?.kelurahanname, value: data?.kelurahan?.id},
                zipCode: {label: data?.zipCode, value: data?.zipCode},
                gender: {label: data?.gender?.value, value: data?.gender?.key},
                job1: {label: data?.job1?.value, value: data?.job1?.key},
                job2: {label: data?.job2?.value, value: data?.job2?.key},
                religion: {label: data?.religion?.value, value: data?.religion?.key},
                interest: Array.isArray(data?.interest) && data.interest.length > 0
                    ? {
                        label: data.interest[0].value,
                        value: data.interest[0].key,
                    }
                    : data?.interest
                        ? {
                            label: data.interest.value,
                            value: data.interest.key,
                        }
                        : null,
                hobby: Array.isArray(data?.hobby) && data.hobby.length > 0
                    ? {
                        label: data.hobby[0].value,
                        value: data.hobby[0].key,
                    }
                    : data?.hobby
                        ? {
                            label: data.hobby.value,
                            value: data.hobby.key,
                        }
                        : null,
            };
        }

        if (res[2].ok && res[2].data.status === HttpStatus.SUCCESS) {
            const {data} = res[2].data;
            dataUnit = {
                kodeVariant: {label: data?.dataVariant?.kodeVariant, value: data?.dataVariant?.kodeVariant},
                namaVariant: data?.dataVariant?.namaVariant,
                idWarna: {label: data?.dataWarna?.kodeWarna, value: data?.dataWarna?.id},
                namaWarnaKomersil: data?.dataWarna?.namaWarnaKomersil,
                tipe: data?.dataTypeAndSeriesDTO?.typeName,
                series: data?.dataTypeAndSeriesDTO?.seriesDTO?.seriesName,
                nomorMesin: data?.noSin,
                nomorRangka: data?.noKa,
            };
        }

        error = [res[0], res[1], res[2]]
            .some(r => r.ok && r.data.status === HttpStatus.FAILED);

        data = {
            dataPembeli,
            dataPemilik,
            dataUnit,
        }
    }

    return {
        error: error,
        data: data
    };
}

const parseDataPersonal = (data, type) => {
    const {
        province,
        kecamatan,
        kelurahan,
        kabkot,
        perusahaan,
        isCompany,
        isBuyer,
        isMakelarProfessional,
        memberId,
        jenisProspectH1,
        jenisProspectH23,
        ...filteredData
    } = data;

    let check = null;
    if (type === "dataPembeli") {
        check = {perusahaan: isCompany}
    } else if (type === "dataPemilik") {
        check = {pembeli: isBuyer}
    } else if (type === "dataReferral") {
        check = {makelarProfessional: isMakelarProfessional}
    }
    if (type === "dataReferral" && Object.values(data).every((val) => val === false || val === null || R.isEmpty(val))) {
        return null;
    }


    return {
        ...filteredData,
        ...(check ? check : {}),
        customerId: memberId,
        provinceId: province?.value || null,
        kabkotId: kabkot?.value || null,
        kecamatanId: kecamatan?.value || null,
        kelurahanId: kelurahan?.value || null,
        zipCode: filteredData?.zipCode?.value || null,
        job1: filteredData?.job1?.value || null,
        job2: filteredData?.job2?.value || null,
        gender: filteredData?.gender?.value || null,
        religion: filteredData?.religion?.value || null,
        hobby: filteredData?.hobby?.value ? [filteredData?.hobby?.value] : null,
        interest: filteredData?.interest?.value ? [filteredData?.interest?.value] : null,
    }
}

const parseDataUnit = (data) => {
    const {namaVariant, namaWarnaKomersil, series, tipe, ...filteredData} = data;
    const isSelectNokaNosin = filteredData?.nomorRangka || filteredData?.nomorMesin;
    return {
        ...filteredData,
        kodeVariant: isSelectNokaNosin ? filteredData?.kodeVariant?.value : filteredData?.kodeVariant?.label || null,
        idWarna: filteredData?.idWarna?.value || null,
    }
}

const parseDataPackage = (data, nomorFakturJual) => {
    const listType = ["barangLain", "hadiah", "ksu", "part"];
    const kodeFieldMap = {
        barangLain: "kodeBarangLain",
        hadiah: "kodeHadiah",
        ksu: "kodeKSU",
        part: "kodePart"
    };
    const dataPackage = {};
    listType.forEach(type => {
        dataPackage[type] = data.dataTable[type] = data.dataTable[type].map(item => ({
            [kodeFieldMap[type]]: item.kode,
            nomorFakturJual: nomorFakturJual,
            qty: item.jumlah
        }))
    });

    return {
        ...dataPackage,
        packageId: data.selectedPackage?.value,
        selectedPackage: data.selectedPackage?.value,
    }
}

const parseDataTransaction = (data) => {
    const {detailTransaction, headerTransaction} = data;
    const {pembayaranKonsumen, pembayaranUnit, dataTransaksiTambahan} = detailTransaction;
    const {ppn, ...filteredDataTransaksiTambahan} = dataTransaksiTambahan;
    const {
        hargaOtrOff,
        idSalesProgramDgi,
        tipeHargaUnit,
        salesPersonId,
        hargaDiberikan,
        ...filteredHeaderTransaction
    } = headerTransaction;
    const detail = {
        dataTransaksiTambahan: {
            ...filteredDataTransaksiTambahan,
            ppn: ppn?.value,
        },
        pembayaranKonsumen: {
            nilaiHarusSetor: pembayaranKonsumen?.nilaiHarusSetor || 0,
            dibayarTunai: pembayaranKonsumen?.dibayarTunai === "" ? null : pembayaranKonsumen?.dibayarTunai || 0,
            dibayarTransfer: pembayaranKonsumen?.dibayarTransfer === "" ? null : pembayaranKonsumen?.dibayarTransfer || 0,
            bankId: pembayaranKonsumen?.bank?.value || null,
            dibayarRumah: pembayaranKonsumen?.dibayarRumah === "" ? null : pembayaranKonsumen?.dibayarRumah || 0,
            cashTempo: pembayaranKonsumen?.cashTempo === "" ? null : pembayaranKonsumen?.cashTempo || 0,
            tanggalDeadlineTempo: pembayaranKonsumen?.tanggalDeadlineTempo
        },
        pembayaranUnit: {
            leasingId: pembayaranUnit?.leasing?.value || null,
            tipePayment: pembayaranUnit?.tipePayment?.value || null,
            salesProgramId: pembayaranUnit?.salesProgramId?.value,
            dpPo: pembayaranUnit?.dpPo === "" ? null : pembayaranUnit?.dpPo || 0,
            subsidiUmLeasing: pembayaranUnit?.subsidiUmLeasing === "" ? null : pembayaranUnit?.subsidiUmLeasing || 0,
            angsuran: pembayaranUnit?.angsuran === "" ? null : pembayaranUnit?.angsuran || 0,
            tenor: pembayaranUnit?.tenor === "" ? null : pembayaranUnit?.tenor || 0,
            noPo: pembayaranUnit?.noPo,
            discountMax: pembayaranUnit?.discountMax || 0,
            discountMin: pembayaranUnit?.discountMin || 0,
            discountDiberikan: pembayaranUnit?.discountDiberikan === "" ? null : pembayaranUnit?.discountDiberikan || 0,
            mk: pembayaranUnit?.mk === "" ? null : pembayaranUnit?.mk || 0,
            overDiscount: pembayaranUnit?.overDiscount || 0,
            tk: pembayaranUnit?.tk === "" ? null : pembayaranUnit?.tk || 0,
            biayaLainlain: pembayaranUnit?.biayaLainlain === "" ? null : pembayaranUnit?.biayaLainlain || 0,
            scpAhm: pembayaranUnit?.scpAhm === "" ? null : pembayaranUnit?.scpAhm || 0,
            scpMd: pembayaranUnit?.scpMd === "" ? null : pembayaranUnit?.scpMd || 0,
            scpDealer: pembayaranUnit?.scpDealer === "" ? null : pembayaranUnit?.scpDealer || 0,
            subsidiLain: pembayaranUnit?.subsidiLain === "" ? null : pembayaranUnit?.subsidiLain || 0,
            tentative: pembayaranUnit?.tentative
        }
    }

    return {
        ...filteredHeaderTransaction,
        hargaDiberikan: hargaDiberikan === "" ? null : hargaDiberikan || 0,
        salesPersonId: salesPersonId?.value,
        salesType: salesPersonId?.salesType,
        jumlahHarga: hargaOtrOff || 0,
        idSalesProgramDGI: idSalesProgramDgi,
        typeHargaUnit: tipeHargaUnit,
        ...detail
    }
}

const parseDataDelivery = (data) => {
    return {
        alamat: data.alamat || null,
        catatan: data.catatan || null,
        kodeKabkot: data.kabKot?.value || null,
        kodeKecamatan: data.kecamatan?.value || null,
        kodeKelurahan: data.kelurahan?.value || null,
        kodePos: data.kodePos?.value || null,
        kodeProvinsi: data.province?.value || null,
        patokan: data.patokan || null,
        tipeAlamatPengiriman: data.alamatType || null,
    }
}

const constructSalesOrderRequestPayload = (data) => {
    const {
        nomorFakturJual,
        tanggalFakturJual,
        kodeCabang,
        indentNo,
        prospectNo,
        jenisProspect,
        statusFakturJual
    } = data;
    const dataPembeli = parseDataPersonal(data.dataPembeli, "dataPembeli");
    const dataPemilik = parseDataPersonal(data.dataPemilik, "dataPemilik");
    const dataReferral = parseDataPersonal(data.dataReferral, "dataReferral");
    const dataUnit = parseDataUnit(data.dataUnit);
    const dataPackage = parseDataPackage(data.dataPackage, nomorFakturJual);
    const dataTransaction = parseDataTransaction(data.dataTransaction);
    const dataDelivery = parseDataDelivery(data.dataDelivery);
    return {
        nomorFakturJual,
        tanggalFakturJual,
        kodeCabang: kodeCabang?.value,
        ...(indentNo ? {indentNo: indentNo} : {indentNo: null}),
        ...(prospectNo ? {prospectNo: prospectNo} : {prospectNo: null}),
        ...(statusFakturJual ? {statusFakturJual: statusFakturJual} : {statusFakturJual: null}),
        ...(jenisProspect ? {jenisProspect: jenisProspect} : {jenisProspect: null}),
        dataPembeli: dataPembeli,
        dataPemilik: dataPemilik,
        dataReferral: dataReferral,
        dataPhotos: data.dataPhoto,
        dataUnit: dataUnit,
        dataPackage: dataPackage,
        dataTransaction: dataTransaction,
        dataDelivery: dataDelivery,
        note: data.dataNote?.note || null
    }
}

const constructSalesOrderRequestDGI = (data) => {
    const {nomorFakturJual} = data;
    let salesOrderSubmitRequestDTO = {
        ...constructSalesOrderRequestPayload(data),
    };
    return {
        nomorFakturJualDGI: nomorFakturJual,
        salesOrderSubmitRequestDTO,
    }
};

const getDataFromGroup = () => {
    const {
        dataPembeli,
        dataPemilik,
        dataDelivery,
        dataReferral,
        dataPhoto,
        dataKeterangan,
        dataUnit,
        dataPackage,
        dataTransaction,
        pembayaranUnit,
        pembayaranKonsumen,
        ...fg
    } = formGroup;
    return {
        fgPembeli: dataPembeli,
        fgPemilik: dataPemilik,
        fgDelivery: dataDelivery,
        fgReferral: dataReferral,
        fgPhoto: dataPhoto,
        fgKeterangan: dataKeterangan,
        fgUnit: dataUnit,
        fgPackage: dataPackage,
        fgTransaction: dataTransaction,
        fgPembayaranUnit: pembayaranUnit,
        fgPembayaranKonsumen: pembayaranKonsumen,
        ...fg
    }
}

const validate = (data, penjualIsMakelar, isMakelarProfesional) => {
    const {
        fgPembeli,
        fgPemilik,
        fgDelivery,
        fgReferral,
        fgPhoto,
        fgKeterangan,
        fgUnit,
        fgPackage,
        fgTransaction,
        fgPembayaranKonsumen,
        fgPembayaranUnit,
        ...fg
    } = getDataFromGroup();

    const {
        dataPembeli,
        dataPemilik,
        dataDelivery,
        dataReferral,
        dataPhotos,
        dataKeterangan,
        dataUnit,
        dataPackage,
        dataTransaction,
        ...filteredData
    } = data;

    const {pembayaranKonsumen, pembayaranUnit} = dataTransaction;

    let newErrors = {
        dataPembeli: {},
        dataPemilik: {},
        dataDelivery: {},
        dataReferral: {},
        dataPhoto: {},
        dataKeterangan: {},
        dataUnit: {},
        dataPackage: {},
        dataTransaction: {},
        isMkNotNull: false
    };

    const mk = dataTransaction?.pembayaranUnit?.mk;
    if (!R.isNil(mk) && !R.isEmpty(mk) && mk > 0 && (R.isNil(dataReferral?.name) || R.isEmpty(dataReferral?.name))) {
        newErrors["isMkNotNull"] = true;
    } else {
        newErrors["isMkNotNull"] = false;
    }

    for (const [key, val] of Object.entries(fg)) {
        const message = validateEmptyValue(key, val, filteredData);
        if (message) {
            newErrors[key] = message;
        }
    }

    for (const [key, val] of Object.entries(fgTransaction)) {
        const message = typeof val.value === 'number'
            ? validateNumberNotZero(key, val, dataTransaction)
            : validateEmptyValue(key, val, dataTransaction);
        if (message) {
            newErrors["dataTransaction"] = {
                ...newErrors["dataTransaction"],
                [key]: message
            };
        }
    }

    for (const [key, val] of Object.entries(fgPembayaranKonsumen)) {
        const message = R.equals("nilaiHarusSetor", key)
            ? calculateSelisih(pembayaranKonsumen)
            : typeof val.value === 'number'
                ? validateNumberNotZero(key, val, pembayaranKonsumen)
                : validateEmptyValue(key, val, pembayaranKonsumen);
        if (message) {
            newErrors["pembayaranKonsumen"] = {
                ...newErrors["pembayaranKonsumen"],
                [key]: message
            };
        }
    }

    for (const [key, val] of Object.entries(fgPembayaranUnit)) {
        const message = typeof val.value === 'number'
            ? validateNumberNotZero(key, val, pembayaranUnit)
            : validateEmptyValue(key, val, pembayaranUnit);
        if (message) {
            newErrors["pembayaranUnit"] = {
                ...newErrors["pembayaranUnit"],
                [key]: message
            };
        }
    }

    for (const [key, val] of Object.entries(fgPembeli)) {
        const message = validateEmptyValue(key, val, dataPembeli);
        if (message) {
            newErrors["dataPembeli"] = {
                ...newErrors["dataPembeli"],
                [key]: message
            };
        }
    }

    for (const [key, val] of Object.entries(fgPemilik)) {
        const message = validateEmptyValue(key, val, dataPemilik);
        if (message) {
            newErrors["dataPemilik"] = {
                ...newErrors["dataPemilik"],
                [key]: message
            };
        }
    }

    for (const [key, val] of Object.entries(fgDelivery)) {
        const message = validateEmptyValue(key, val, dataDelivery);
        if (message) {
            newErrors["dataDelivery"] = {
                ...newErrors["dataDelivery"],
                [key]: message
            };
        }
    }

    if (!newErrors.isMkNotNull && !penjualIsMakelar && isMakelarProfesional) {
        for (const [key, val] of Object.entries(fgReferral)) {
            const message = validateEmptyValue(key, val, dataReferral);
            if (message) {
                newErrors["dataReferral"] = {
                    ...newErrors["dataReferral"],
                    [key]: message
                };
            }
        }
    }

    for (const [key, val] of Object.entries(fgPhoto)) {
        const message = validateEmptyValue(key, val, dataPhotos);
        if (message) {
            newErrors["dataPhoto"] = {
                ...newErrors["dataPhoto"],
                [key]: message
            };
        }
    }

    for (const [key, val] of Object.entries(fgKeterangan)) {
        const message = validateEmptyValue(key, val, dataKeterangan);
        if (message) {
            newErrors["dataKeterangan"] = {
                ...newErrors["dataKeterangan"],
                [key]: message
            };
        }
    }

    for (const [key, val] of Object.entries(fgUnit)) {
        const message = validateEmptyValue(key, val, dataUnit);
        if (message) {
            newErrors["dataUnit"] = {
                ...newErrors["dataUnit"],
                [key]: message
            };
        }
    }

    for (const [key, val] of Object.entries(fgPackage)) {
        const message = validateEmptyValue(key, val, dataPackage);
        if (message) {
            newErrors["dataPackage"] = {
                ...newErrors["dataPackage"],
                [key]: message
            };
        }
    }

    if (pembayaranUnit?.tipePayment === "CREDIT") {
        for (const [key, val] of Object.entries(pembayaranUnit)) {
            const message = validatePembayaranUnitCredit(key, pembayaranUnit);
            if (message) {
                newErrors["pembayaranUnit"] = {
                    ...newErrors["pembayaranUnit"],
                    [key]: message
                };
            }
        }
    }

    // if (pembayaranUnit?.tipePayment === "CASH") {
    // }
    for (const [key, val] of Object.entries(pembayaranKonsumen)) {
        const message = validatePembayaranKonsumen(key, pembayaranKonsumen);
        if (message) {
            newErrors["pembayaranKonsumen"] = {
                ...newErrors["pembayaranKonsumen"],
                [key]: message
            };
        }
    }

    if (!dataPembeli?.perusahaan) {
        if (R.or(!dataPembeli?.nik, R.isEmpty(dataPembeli?.nik))) {
            newErrors["dataPembeli"] = {
                ...newErrors["dataPembeli"],
                nik: "Field belum diisi"
            }
        }
        if (dataPembeli.nik) {
            if (newErrors["dataPembeli"]?.nik) {
                delete newErrors["dataPembeli"]?.nik
            }
        }
    }

    if (!dataPemilik?.pembeli) {
        if (R.or(!dataPemilik?.nik, R.isEmpty(dataPemilik?.nik))) {
            newErrors["dataPemilik"] = {
                ...newErrors["dataPemilik"],
                nik: "Field belum diisi"
            }
        }
    }

    if (!newErrors.pembayaranUnit) {
        newErrors.pembayaranUnit = {}
    }

    if (dataPembeli.perusahaan) {
        if (newErrors["dataPembeli"]?.nik) {
            delete newErrors["dataPembeli"]?.nik
        }
        if (dataPemilik.pembeli && newErrors["dataPemilik"]?.nik) {
            delete newErrors["dataPemilik"]?.nik
        }
    }
    return newErrors
}

const validateDGI = (data, penjualIsMakelar, isMakelarProfesional) => {
    const {salesOrderSubmitRequestDTO, ...rest} = data;
    return validate(salesOrderSubmitRequestDTO, penjualIsMakelar, isMakelarProfesional);
};

function validatePembayaranKonsumen(key, data) {
    let tf = parseInt(data?.dibayarTransfer);
    let ct = parseInt(data?.cashTempo);

    if (R.or(R.and(R.equals(key, "bankId", R.or(typeof tf !== 'number', isNaN(tf))), data.dibayarTransfer > 0),
        R.and(R.equals(key, "tanggalDeadlineTempo", R.or(typeof ct !== 'number', isNaN(ct))), data.cashTempo > 0))) {
        if (R.or(R.isNil(data?.[key]), R.isEmpty(data?.[key]))) {
            return "Field belum diisi";
        }
    }
    return null;
}

function validatePembayaranUnitCredit(key, data) {
    let keys = ["leasingId", "dpPo", "noPo", "tenor", "angsuran", "subsidiUmLeasing"];
    if (keys.includes(key)) {
        if (R.or(R.equals(key, "noPo"), R.equals(key, "leasingId"))) {
            if (R.isNil(data?.[key]) || R.isEmpty(data?.[key])) {
                return "Field belum diisi";
            }
        } else {
            if (R.or(R.isNil(data?.[key]), typeof parseInt(data?.[key]) !== 'number', isNaN(parseInt(data?.[key])))) {
                return "Field belum diisi"
            }

        }
    }
    return null;
}

function calculateSelisih(data) {
    const harusSetor = parseInt(data?.nilaiHarusSetor);
    const dibayarTunai = parseInt(data?.dibayarTunai) || 0;
    const dibayarTransfer = parseInt(data?.dibayarTransfer) || 0;
    const dibayarRumah = parseInt(data?.dibayarRumah) || 0;
    const cashTempo = parseInt(data?.cashTempo) || 0;
    const totalSetor = dibayarTunai + dibayarTransfer + dibayarRumah + cashTempo;
    if (harusSetor - totalSetor !== 0) {
        return "Selisih Harus 0";
    }
    return null;
}

function validateEmptyValue(key, val, data) {

    if (R.and(val.mandatory, R.or(!data?.[key], R.isEmpty(data?.[key])))) {
        return "Field belum diisi";
    }

    return null;
}

function validateNumberNotZero(key, val, data) {
    if (R.and(val.mandatory, R.or(R.isNil(data?.[key]), typeof parseInt(data?.[key]) !== 'number', isNaN(parseInt(data?.[key]))))) {
        return "Field belum diisi";
    }
    return null;
}

function getDiscountMaxByMarketingLevel(salesPerson, data) {
    if (R.isNil(data)) {
        return 0;
    } else if (!R.isNil(salesPerson) && !R.isEmpty(salesPerson) && salesPerson.marketingLevel === 1) {
        return data.nominalLevel1;
    } else if (!R.isNil(salesPerson) && !R.isEmpty(salesPerson) && salesPerson.marketingLevel === 2) {
        return data.nominalLevel2;
    } else if (!R.isNil(salesPerson) && !R.isEmpty(salesPerson) && salesPerson.marketingLevel === 3) {
        return data.nominalLevel3;
    } else if (!R.isNil(salesPerson) && !R.isEmpty(salesPerson) && salesPerson.marketingLevel === 4) {
        return data.nominalLevel4;
    } else if (!R.isNil(salesPerson) && !R.isEmpty(salesPerson) && salesPerson.marketingLevel === 5) {
        return data.nominalLevel5;
    } else if (!R.isNil(salesPerson) && !R.isEmpty(salesPerson) && salesPerson.marketingLevel === 6) {
        return data.nominalLevel6;
    } else if (!R.isNil(salesPerson) && !R.isEmpty(salesPerson) && salesPerson.marketingLevel === 7) {
        return data.nominalLevel7;
    } else if (!R.isNil(salesPerson) && !R.isEmpty(salesPerson) && salesPerson.marketingLevel === 8) {
        return data.nominalLevel8;
    } else {
        return 0;
    }
}

function downloadPdf(blob, fileName) {
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

export const service = {
    fetchDataDetail,
    constructSalesOrderRequestPayload,
    validate,
    validateDGI,
    getDiscountMaxByMarketingLevel,
    constructSalesOrderRequestDGI,
    downloadPdf,
}
